module.exports = __webpack_public_path__ + "img/yanpiao.7d7e085b.jpg";